import Application from 'components/Application';
import Design from 'components/Design';
import Layout from 'components/Layout';
import SEO from 'components/seo';
import React from 'react';

const ComachiPage = () => {

  return (
    <Layout>
      <SEO title='comachicart' path='design' />
      <Design />
      <Application />
    </Layout>
  );
};

export default ComachiPage;
